// Inicialização do Sentry. Precisa ser o PRIMEIRO import de main.tsx, de
// proposito, para que erros de carregamento dos proprios modulos da
// aplicacao ja sejam capturados.
//
// Sentry e opcional por padrao: sem VITE_SENTRY_DSN definida, o SDK nao
// inicializa e a aplicacao sobe normalmente, sem overhead e sem quebrar o
// build/boot.
import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,

    integrations: [
      // Mede carregamento de pagina e navegacao entre rotas, e registra
      // cada chamada de fetch como breadcrumb — e assim que se ve o que
      // o usuario fez ANTES do erro.
      Sentry.browserTracingIntegration(),
    ],

    // Fracao das navegacoes/interacoes com trace de performance. Erros
    // continuam sendo sempre capturados (100%), independente deste valor.
    tracesSampleRate: 0.1,

    // Nao envia IP nem dados de formulario automaticamente. O usuario e
    // anexado explicitamente apos o login (ver src/lib/sentryUser.ts).
    sendDefaultPii: false,

    // Ruido que nao e bug da aplicacao.
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "Non-Error promise rejection captured",
    ],
    denyUrls: [/extensions\//i, /^chrome:\/\//i, /^moz-extension:\/\//i],
  });

  console.log(
    `[sentry] ativo — environment=${import.meta.env.MODE}`,
  );
} else {
  console.log("[sentry] VITE_SENTRY_DSN nao definida — monitoramento desativado");
}
